"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const piral_core_1 = require("piral-core");
const components_1 = require("@smapiot/components");
const Notification = ({ id, title, type, onClose, children }) => {
    const dismiss = (ev) => {
        onClose();
        ev.preventDefault();
    };
    return (React.createElement(components_1.NotificationCard, { className: `notification-card-${type}`, title: title, actions: React.createElement("a", { href: "#", title: "Dismiss", onClick: dismiss },
            React.createElement("i", { className: "fas fa-trash" })) }, children));
};
const NoNotifications = () => (React.createElement("div", { className: "empty-teaser" },
    React.createElement("h5", null, "There are no notifications to display right now.")));
exports.default = () => {
    const notifications = (0, piral_core_1.useGlobalState)((m) => m.notifications);
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "light-background" },
            React.createElement("div", { className: "container" },
                React.createElement("h1", null, "Notifications"),
                notifications.length === 0 ? (React.createElement(NoNotifications, null)) : (React.createElement(React.Fragment, null, notifications.map((notification) => (React.createElement(Notification, { id: notification.id, key: notification.id, title: notification.options.title, onClose: notification.close, type: notification.options.type },
                    React.createElement(notification.component, { onClose: notification.close, options: notification.options }))))))))));
};
